import MobileFiles from './MobileFiles';

/*********************************************************************
 * 
 *               Upload file from phone camera roll
 * 
 ********************************************************************/

const _getFileBlob = (url, cb) => {
  if (url.startsWith('file') && MobileFiles.available()) {
    MobileFiles.loadBlobFromFilename(url).then((blob) => {
      cb(blob);
    });
  }
  else {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.withCredentials = true;
    xhr.addEventListener('load', () => {
      cb(xhr.response);
    });
    xhr.send();
  }
};

const _blobToFile = (blob, name) => {
  blob.lastModifiedDate = new Date();
  blob.name = name;
  return blob;
};

export const getFileObject = (filePathOrUrl, cb) => {
  _getFileBlob(filePathOrUrl, blob => {
    const name = filePathOrUrl.substr(filePathOrUrl.lastIndexOf('/') + 1);
    cb(_blobToFile(blob, name));
  });
};

/*********************************************************************
 * 
 *       Download and save file to phone and display functions
 * 
 ********************************************************************/

 // Error Handlers

const _onErrorCreateFile = () => {
};
const _onErrorReadFile = () => {
};

// Helper Functions

const _displayImage = (blob) => {
  // Displays image if result is a valid DOM string for an image.
  // var elem = document.getElementById('imageFile');
  // Note: Use window.URL.revokeObjectURL when finished with image.
  // elem.src = window.URL.createObjectURL(blob);
};

// Non Images

const _readFile = (fileEntry) => {
  fileEntry.file(function(file) {
    var reader = new FileReader();
    reader.onloadend = function() {
          // displayFileData(fileEntry.fullPath + ": " + this.result);
    };
    reader.readAsText(file);
  }, _onErrorReadFile);
};

// Images
const _readBinaryFile = (fileEntry) => {
  fileEntry.file(function(file) {
    var reader = new FileReader();
    reader.onloadend = function() {
          // displayFileData(fileEntry.fullPath + ": " + this.result);
      var blob = new Blob([new Uint8Array(this.result)], { type: 'image/png' });

      _displayImage(blob);
    };
    reader.readAsArrayBuffer(file);
  }, _onErrorReadFile);
};

const _writeFile = (fileEntry, dataObj, isAppend) => {
  // Create a FileWriter object for our FileEntry (log.txt).
  fileEntry.createWriter(function(fileWriter) {
    fileWriter.onwriteend = function() {
      if (dataObj.type == 'image/png') {
        _readBinaryFile(fileEntry);
      }
      else {
        _readFile(fileEntry);
      }
    };
    fileWriter.onerror = function(e) {
    };
    fileWriter.write(dataObj);
  });
};

const _saveFile = (dirEntry, fileData, fileName) => {
  dirEntry.getFile(fileName, { create: true, exclusive: false }, function(fileEntry) {
    _writeFile(fileEntry, fileData);
  }, _onErrorCreateFile);
};

/**
 * Get File
 * @param { dirEntry } string - Path of file saved
 * downloads a url and writes it to tmp storage
 * 
 * example usage
 * 
 * import { download } from 'path/to/helpers/CordovaHelpers'
 *  window.requestFileSystem(window.TEMPORARY, 5 * 1024 * 1024, function (fs) {
      downloadFile(fs.root, attachment.upload, attachment.name);
    });
 */

export const downloadFile = (dirEntry, url, fileName) => {
  var xhr = new XMLHttpRequest();

  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    let contentType = xhr.getResponseHeader('Content-Type');
    if (this.status == 200) {
      var blob = new Blob([this.response], { type: contentType });
      _saveFile(dirEntry, blob, fileName);
    }
  };
  xhr.send();
};




// WEBPACK FOOTER //
// ./src/helpers/CordovaHelpers.js